module.exports = "https://static.wmbcdn.com/uniweb/images/91c11be23cce85b26203f292cf172646.svg";